<template>
	<div id="app">
		<Layout v-if="authorizd">
            <Sider ref="side1" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed">
            
                <div class="logo" style="background-image: url('/static/img/logo.png');">
                    路易报表 
                </div>
                <div class="menu-content">
                    <div class="menu-content__scroll">
                        <Menu theme="dark" width="auto" :class="menuitemClasses" @on-select="menuSelect" accordion>
                            <Submenu v-for="(sub, i) in config.config" :name="sub.label" :key="i" v-if="sub.power.isShow != false">
                                <template slot="title">
                                    <Icon :type="sub.icon" />
                                    <span>{{sub.title}}</span>
                                </template>
                                <template v-for="(item, k) in sub.children">                                    
                                    <MenuItem :name="item.label" 
                                        :class="{'ivu-menu-item-active': ($route.name && $route.name.indexOf(item.label+'_') >=0) }" 
                                        v-if="item.power.isShow != false">
                                        <Icon :type="item.icon"></Icon>
                                        <span>{{item.title}}</span>
                                    </MenuItem>
                                </template>
                            </Submenu>
                        </Menu>
                    </div>
                </div>
            </Sider>
            <Layout>
                <Header :style="{padding: 0, marginBottom: '2px'}" class="layout-header-bar">
                    <Row>
                        <Col span="4">
                            <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{margin: '0 20px'}" type="md-menu" size="24"></Icon>
                        </Col>
                        <Col span="20" class="login-info">
                            <span> <i class="fa fa-send"></i> 您好{{account.type}}：{{account.name}}</span>
                            
                            <!-- <span @click="isShowModal=true">修改密码</span> -->
                            <span @click="logOut"> <i class="fa fa-sign-out"></i> {{account.account}} 登出</span>
                        </Col>
                    </Row>
                </Header>
                <Content :style="{padding: '20px'}" id="layout-content">
					<router-view/>
                </Content>
            </Layout>
        </Layout>
        <login v-else></login>
	</div>
</template>

<script>
    import { mapGetters, mapActions } from 'Vuex'
    import Login from '@/views/login'
    import FormMixin from '@/utils/form.mixin'
	export default {
        components: {Login},
        mixins: [FormMixin],
        data () {
            return {
                local_version: 'LOCAL_VERSOIN', // 本地版本信息的存储KEY
                local_config: 'LCOAL_CONFIG', // 本地配置信息存储的KEY
                version_value: '', // 版本好信息
                isShowModal: false, // 修改密码的弹出层
                isCollapsed: false,
                isLoading: false,
                isInit: false, // 标识是否初始化了配置文件
                bindForm: {
                    password: '',
                    password_ag: ''
                },
                ruleCustom: {} ,// 验证规则 
                account: {}, // 账号信息
                isHubbleMode: false, // 2019-10-30添加，是否区分显示模式
            }
        },
        computed: {
            ...mapGetters(['config', 'currMenu', 'authorizd', 'clientId', 'logo', 'miniLogo']),
            rotateIcon () {
                return [
                    'menu-icon',
                    this.isCollapsed ? 'rotate-icon' : ''
                ];
            },
            menuitemClasses () {
                return [
                    'menu-item',
                    this.isCollapsed ? 'collapsed-menu' : ''
                ]
            },
            /**
             * 根据对应的clientId返回client名称
             */
            env () {
                let str = 'niuzhan'
                return str
            }
        },
        watch: {
            authorizd: {
                handler () {
                    if (this.authorizd) {
                        this.isInit = true                        
                        this.setTitle()
                        this.initAccount()
                        // 设置标题
                    }
                },
                immediate: true
            }
        },
        created () {
            // 初始化 clientID和环境标识
            this.setTitle()
            // 设置表单的验证规则
            this.ruleCustom.password = [
                this.ruleValidate.empty,
                this.ruleValidate.password
            ]
            this.ruleCustom.password_ag = [
                this.ruleValidate.empty,
                this.ruleValidate.passwdCheck
            ]

        },
        methods: {
            ...mapActions(['initConfig', 'setCurrMenu', 'initClientId', 'updateAuthorizd', 'setHubbleId', 'initUserInfo']),
            setTitle () {
                this.initClientId({
                    id: 'pc_001',
                    env: 'pc',
                    logo: '',
                    miniLogo: '',
                    background: ''
                })
            },
            collapsedSider () {
                this.$refs.side1.toggleCollapse();
			},
			menuSelect (select) {
                this.setCurrMenu(select)
                let firstPage = this.currMenu.page[0]
                if (firstPage.target) { // 打开新页面
                    window.open(firstPage.route)
                } else {
                    this.$router.push({path: firstPage['route']})
                }
            },
            /**
             * 初始化读取配置文件
             */
            queryConfig () {
                let config = null
                // 获取本定存储的版本号
                let localVersion = localStorage.getItem(this.local_version)
                // 版本号未变获取本地配置
                if (localVersion  && localVersion.length > 0 && this.version_value == localVersion) {
                    config = localStorage.getItem(this.local_config)
                    if (config) {
                        config = JSON.parse(config)
                    }
                }
                // 本地存储版本号
                localStorage.setItem(this.local_version, this.version_value)
                // config不存在时，服务器获取
                if (!config) {
                    this.$api.query('pc/config').then((rs) => {
                        this.initConfig(rs)
                        rs.config && this.initRouter(rs.config)
                        // 本地存储config
                        localStorage.setItem(this.local_config,  JSON.stringify(rs))
                    })
                } else { // 使用本地config初始化
                    this.initConfig(config)
                    config.config && this.initRouter(config.config)
                }
            },
            /**
             * 路由的初始化
             */
            initRouter (config) {
                // 2019-10-30 当前是否是区分路由
                if (this.$route.name == 'hubble') {
                    this.isHubbleMode = true
                    this.setHubbleId(this.$route.params.id)
                }
                let routes = []
                config.forEach(el => {
                    if (!el.hasOwnProperty('isHubble')) { el.isHubble = false }
                    // 2019-10-30区分状态与当前模式一样才 加入路由
                    if (el.isHubble === this.isHubbleMode) {
                        // 2020-09-02添加，要根据权限来设置路由
                        el.power = this.routerPower(el.label, this.account.power || [])
                        el.power.isShow && el.children.forEach(child => { // 二级菜单
                            // 二级菜单的权限
                            child.power = this.routerPower(child.label, el.power.children)
                            child.power.isShow && child.page.forEach(page => { // 菜单下的页面
                                //页面权限
                                page.power = this.routerPower(page.label, child.power.children)
                                // 有target代表跳转新页面
                                if (!page.target && page.power.isShow) {
                                    // 添加一个默认路由
                                    if (routes.length < 1) {
                                        routes.push({
                                            path: '/',
                                            name: page.label,
                                            component: r => require.ensure([], () => r(require('@/views/main.vue')))
                                        })
                                    }
                                    // 创建路由
                                    routes.push({
                                        path: page.route,
                                        name: page.label,
                                        component: r => require.ensure([], () => r(require('@/views/main.vue')))
                                    })
                                }
                            })
                        })
                    }
                })
                this.$router.addRoutes(routes)
                // 如果是区分显示模式，跳转到默认页面  2019-10-30
                if (this.isHubbleMode) {
                    this.$router.replace({path: '/'})
                }
            },
            /**
             * 路由的权限设置
             * @param label 路由的label
             * @param arr 权限配置的数组
             */
            routerPower (label, arr) {
                let obj = {
                    isShow: true,
                    children: []
                }
                for (let i = 0, len = arr.length; i < len; i++) {
                    if (label == arr[i]['label']) {
                        obj.isShow = arr[i]['isShow']
                        obj.children = arr[i]['children'] || arr[i]['btns']
                        break;
                    }
                }
                return obj
            },
            /**
             * 初始化获得账号信息
             */
            initAccount () {
                // let EnvNow = this.env == 'member' ? 'hlf': this.env
                this.$api.query('pc/account').then((rs) => {
                    // 获得版本号
                    this.version_value = rs.version
                    this.account = rs
                    // 本地存储用户信息
                    this.initUserInfo(rs)
                    // 获取配置
                    this.queryConfig()
                }).catch((err) => {
                    this.$Message.error({content: err, duration: 5 })
                })
            },
            /**
             * 登出功能
             */
            logOut () {
                 this.$Modal.confirm({
                    title: '登出提示',
                    content: '<p>你确定要退出登录?</p>',
                    onOk: () => {
                        const msg = this.$Message.loading({
                            content: '正在退出...',
                            duration: 0
                        });
                        this.$api.create('pc/logout').then((rs) => {
                            this.$Message.success('已退出登录');
                            this.$path.loginOut()
                            msg()
                        }).catch((err) => {
                            msg()
                            this.$Message.error({content: err, duration: 5 })
                        })
                    }
                });
            }
        }
    }
</script>

<style scoped>
	#app, 
	.ivu-layout {
		height: 100%;
    }
    .logo, .miniLogo {
        background-color: #081D3C;
        background-position: center;
        background-repeat: no-repeat;
    }
    .logo {
        position: relative;
        width: 100%;
        height: 65px;
        padding-left: 0;
        background-size: auto 50px;
        text-indent: -999em;
    }
    .miniLogo {
        position: absolute; 
        display: none;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-size: 40px 40px;
    }
    #app .ivu-menu-dark,
    #app .ivu-layout-sider {
        background:#001529;
    }
    .layout{
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-header-bar{
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .layout-logo-left{
        width: 90%;
        height: 30px;
        background: #5b6270;
        border-radius: 3px;
        margin: 15px auto;
    }
    .menu-icon{
        transition: all .3s;
    }
    .rotate-icon{
        transform: rotate(-90deg);
    }
    .menu-item span{
        display: inline-block;
        overflow: hidden;
        width: 69px;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: bottom;
        transition: width .2s ease .2s;
    }
    .menu-item i{
        transform: translateX(0px);
        transition: font-size .2s ease, transform .2s ease;
        vertical-align: middle;
        font-size: 16px;
    }
    .collapsed-menu span{
        width: 0px;
        transition: width .2s ease;
    }
    .collapsed-menu i{
        transform: translateX(5px);
        transition: font-size .2s ease .2s, transform .2s ease .2s;
        vertical-align: middle;
        font-size: 22px;
    }
    #app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item:hover, 
    #app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title:hover {
        background-color: #1890FF;
    }
    /* #app .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-selected{
        background-color: transparent!important;
    } */

    .menu-item span {
        width: 86px;
    }

    .ivu-layout-content {
        overflow-y: auto;
    }
    .ivu-layout-sider-children {
        position: relative;
        overflow: hidden;
    }
    .menu-content {
        position: absolute;
        top: 65px;
        left: 0;
        bottom: 0;
        right: 0;
        overflow: hidden;
    }
    .menu-content__scroll {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: -20px;
        overflow-y:auto;
    }
    /* 登录信息 */
    .login-info {
        text-align: right;
    }
    .login-info span {
        position: relative;
        display: inline-block;
        padding: 0 20px;
        cursor: pointer;
    }
    .login-info span:hover {
        background-color: #fbfbfb;
    }
    .login-info span:first-child:hover{
        background-color: #fff;
    }
    .login-info span::after {
        position: absolute;
        content: " ";
        width: 1px;
        height: 50%;
        top: 25%;
        right: -2px;
        background-color: #eee;
    }
    .login-info span:last-child::after {
        background-color: #fff;
    }
    .menu-item span {
        width: 120px;
    }
    .ivu-menu-submenu .ivu-menu .ivu-menu-item {
        padding-left: 30px!important;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue